//bliver ikke brugt, vi bruger nets cancel side. Må ikke slettes !!!
<template>
    <div class="main">
<div v-if="!error">
    <div v-if="deleted" class="container">
        <img alt="Vue logo" src="../assets/tretrin_nyfuldmagtsside.svg" />
        <h3>Din bestilling er annulleret!</h3>
    </div>
    <div v-else>Anullerer din ordre ...</div>
</div>
        <div v-else>Der er sket en fejl vi sletter den manuelt</div>

    </div>
</template>

<script>
    import {SignerService} from "../services/SignerService";

    export default {
        name: "Abort",
        data(){
            return {
                deleted:false,
                error:false
            }
        },
       async created() {
          const orderId=  this.$route.query.ref;
            console.log(orderId);
     try {
         await  SignerService.delete(orderId);
         this.deleted=true;
     }
     catch (e) {
this.error=true;
     }

        }
    }
</script>
<style lang="scss" scoped>
    #app {
        font-family: "thesansplain", Verdana, sans-serif;
    }
    .container{
        max-width: 800px;
    }
    .main {
        max-width: 1000px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 800px) {
            flex-direction: column-reverse;
        }

        .logo {
            max-width: 300px;
            width: 40%;
            display: flex;
            flex-direction: column;
            @media screen and (max-width: 800px){
                flex-direction: row;
            }
            button{
                align-self: center;
                margin-top:auto;
                @media screen and (max-width: 800px){
                    display:none;
                }
            }

            img {
                width: 100%;
            }
            @media screen and (max-width: 1080px) {
                max-width: calc(600 / 19.2) * 1vw;
            }
            @media screen and (max-width: 800px) {
                display: flex;
                justify-content: center;
                width: 100%;
                max-width: 100%;
                img {
                    width: 50%;
                }
            }
        }
    }
</style>
